module.exports = __webpack_public_path__ + "img/guigang-1.c7371003.png";